// GA4 E-commerce tracking events
// Docs: https://developers.google.com/analytics/devguides/collection/ga4/ecommerce

const gtag = (...args) => {
  if (window.gtag) {
    window.gtag(...args);
  }
};

export const trackViewItem = (product, variation) => {
  gtag('event', 'view_item', {
    currency: 'EUR',
    value: parseFloat(variation?.price || product.price || 0),
    items: [{
      item_id: String(variation?.id || product.id),
      item_name: product.name,
      item_category: product.country_code || 'eSIM',
      price: parseFloat(variation?.price || product.price || 0),
      quantity: 1
    }]
  });
};

export const trackAddToCart = (product) => {
  gtag('event', 'add_to_cart', {
    currency: 'EUR',
    value: parseFloat(product.price || 0),
    items: [{
      item_id: String(product.product_id || product.id),
      item_name: product.name,
      price: parseFloat(product.price || 0),
      quantity: 1
    }]
  });
};

export const trackRemoveFromCart = (item) => {
  gtag('event', 'remove_from_cart', {
    currency: 'EUR',
    value: parseFloat(item.price || 0),
    items: [{
      item_id: String(item.product_id),
      item_name: item.name,
      price: parseFloat(item.price || 0),
      quantity: item.quantity || 1
    }]
  });
};

export const trackBeginCheckout = (cartItems, total) => {
  gtag('event', 'begin_checkout', {
    currency: 'EUR',
    value: total,
    items: cartItems.map(item => ({
      item_id: String(item.product_id),
      item_name: item.name,
      price: parseFloat(item.price || 0),
      quantity: item.quantity || 1
    }))
  });
};

export const trackPurchase = (transactionId, total, items) => {
  gtag('event', 'purchase', {
    transaction_id: transactionId,
    currency: 'EUR',
    value: total,
    items: (items || []).map(item => ({
      item_id: String(item.product_id),
      item_name: item.name,
      price: parseFloat(item.price || 0),
      quantity: item.quantity || 1
    }))
  });
};

export const trackPageView = (pageName) => {
  gtag('event', 'page_view', {
    page_title: pageName,
    page_location: window.location.href
  });
};
